module.exports = __webpack_public_path__ + "img/th-large-solid.1c3ab791.svg";